import { render, staticRenderFns } from "./ImageForm.vue?vue&type=template&id=2be41098"
import script from "./ImageForm.vue?vue&type=script&lang=ts"
export * from "./ImageForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports